import { create } from 'zustand';

const useThemeStore = create((set) => ({
  mode: localStorage.getItem('theme-mode') || 'light',

  toggleMode: () =>
    set((state) => {
      const next = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme-mode', next);
      return { mode: next };
    }),

  setMode: (mode) => {
    localStorage.setItem('theme-mode', mode);
    set({ mode });
  },
}));

export default useThemeStore;
